const attendedPresentationDefaultState = {
  isCreatedNewAttended: false,
}

export default attendedPresentationDefaultState
